import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';

export const useOnEdgeChangeWorkFlowCanvas = () => {
  const { dispatch } = useWorkFlowCanvas();

  return useCallback(
    changes => {
      dispatch({
        type: 'ON-EDGE-CHANGE',
        payload: {
          changes,
        },
      });
    },
    [dispatch],
  );
};
